export const initialAlertingState = {
    alertRulesByProjectIdByAlertRuleId: {},
    alertRuleIdsByProjectId: {},
    alertsByProjectIdByAlertId: {},
    alertIdsByProjectId: {},
};
